import '@babel/polyfill';
import { ResourceConfig } from '@witkac/kartamiejska-resources';
import '@witkac/vue-images/dist/vue-images.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';
import Vue from 'vue';
import vueMoment from 'vue-moment';

import { apolloClient } from './apollo';
import App from './App.vue';
import Datepicker from './components/forms/Datepicker.vue';
import { CheckPermission } from './components/helpers/CheckPermission';
import { formatSize } from './filters/formatSize.filter';
import './plugins/chartist';
import './plugins/vuetify';
import router from './router';
import loaderService from './services/loader.service';
import store from './store/store';

Vue.use(vueMoment as any);
Vue.filter('formatSize', formatSize);

Vue.component('check-permission', CheckPermission as any);
Vue.component('datepicker', Datepicker);

ResourceConfig.setApollo(apolloClient);
ResourceConfig.setLoader(loaderService);

export const eventBus = new Vue();
if (process.env.VUE_APP_ENABLE_DEVTOOLS === 'true') {
  console.log('enable devtools');
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
